import { api } from '../api.js';

// 获取商品分类列表
export const fetchCategories = async (params = {}) => {
    try {
        const response = await api.get('/mall/categories', { params });
        return response;
    } catch (error) {
        console.error('获取分类列表失败:', error);
        throw error;
    }
};

/** 默认租户已有分类（新建分类下拉选项） */
export const fetchCategoryPresets = async () => {
    try {
        const response = await api.get('/mall/categories/presets');
        return response;
    } catch (error) {
        console.error('获取分类选项失败:', error);
        throw error;
    }
};

// 创建分类
export const createCategory = async (categoryData) => {
    try {
        const response = await api.post('/mall/categories', categoryData);
        return response;
    } catch (error) {
        console.error('创建分类失败:', error);
        throw error;
    }
};

// 更新分类
export const updateCategory = async (id, categoryData) => {
    try {
        const response = await api.put(`/mall/categories/${id}`, categoryData);
        return response;
    } catch (error) {
        console.error('更新分类失败:', error);
        throw error;
    }
};

// 删除分类
export const deleteCategory = async (id) => {
    try {
        const response = await api.delete(`/mall/categories/${id}`);
        return response;
    } catch (error) {
        console.error('删除分类失败:', error);
        throw error;
    }
};

// 统一的分类数据处理函数
export const processCategoriesResponse = (response) => {
    if (!response || !response.data) {
        return [];
    }

    const { data } = response;

    // 处理不同的数据结构
    if (Array.isArray(data)) {
        // 直接数组结构
        return data;
    } else if (data.data && Array.isArray(data.data)) {
        // 嵌套数据结构 { data: [...] }
        return data.data;
    } else if (data.list && Array.isArray(data.list)) {
        // 列表数据结构 { list: [...] }
        return data.list;
    } else if (data.content && Array.isArray(data.content)) {
        // 分页数据结构 { content: [...] }
        return data.content;
    }

    return [];
};

// 获取商品列表（config 可传 signal，供列表 AbortController 中断）
export const fetchProducts = async (params = {}, config = {}) => {
    try {
        const response = await api.get('/mall/products', { params, ...config });
        return response;
    } catch (error) {
        console.error('获取商品列表失败:', error);
        throw error;
    }
};

// 获取商品详情
export const fetchProduct = async (id) => {
    try {
        const response = await api.get(`/mall/products/${id}`);
        return response;
    } catch (error) {
        console.error('获取商品详情失败:', error);
        throw error;
    }
};

// 创建商品
export const createProduct = async (productData) => {
    try {
        const response = await api.post('/mall/products', productData);
        return response;
    } catch (error) {
        console.error('创建商品失败:', error);
        throw error;
    }
};

// 更新商品
export const updateProduct = async (id, productData) => {
    try {
        const response = await api.put(`/mall/products/${id}`, productData);
        return response;
    } catch (error) {
        console.error('更新商品失败:', error);
        throw error;
    }
};

// 更新商品状态
export const updateProductStatus = async (id, statusData) => {
    try {
        const response = await api.patch(`/mall/products/${id}/status`, statusData);
        return response;
    } catch (error) {
        console.error('更新商品状态失败:', error);
        throw error;
    }
};

// 批量更新商品状态
export const batchUpdateStatus = async (productIds, statusData) => {
    try {
        const response = await api.post('/mall/products/batch/status', {
            ids: productIds,
            ...statusData
        });
        return response;
    } catch (error) {
        console.error('批量更新商品状态失败:', error);
        throw error;
    }
};

// 删除商品
export const deleteProduct = async (id) => {
    try {
        const response = await api.delete(`/mall/products/${id}`);
        return response;
    } catch (error) {
        console.error('删除商品失败:', error);
        throw error;
    }
};

// 批量删除商品
export const batchDeleteProducts = async (productIds) => {
    try {
        const response = await api.post('/mall/products/batch/delete', {
            ids: productIds
        });
        return response;
    } catch (error) {
        console.error('批量删除商品失败:', error);
        throw error;
    }
};

// 获取商品统计数据
export const fetchProductStats = async (params = {}) => {
    try {
        const response = await api.get('/mall/products/stats', { params });
        return response;
    } catch (error) {
        console.error('获取商品统计数据失败:', error);
        throw error;
    }
};



// 导入商品
export const downloadProductImportTemplate = async () => {
    const response = await api.get('/mall/products/import-template', {
        responseType: 'blob',
    });
    return response;
};

export const importProducts = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await api.post('/mall/products/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response;
    } catch (error) {
        console.error('导入商品失败:', error);
        throw error;
    }
};

// 导出商品
export const exportProducts = async (params = {}) => {
    try {
        const response = await api.get('/mall/products/export', {
            params,
            responseType: 'blob'
        });
        return response;
    } catch (error) {
        console.error('导出商品失败:', error);
        throw error;
    }
};

// 获取订单列表
export const fetchOrders = async (params = {}) => {
    try {
        const response = await api.get('/mall/orders', { params });
        return response;
    } catch (error) {
        console.error('获取订单列表失败:', error);
        throw error;
    }
};

// 获取订单详情
export const fetchOrder = async (id) => {
    try {
        const response = await api.get(`/mall/orders/${id}`);
        return response;
    } catch (error) {
        console.error('获取订单详情失败:', error);
        throw error;
    }
};

// 更新订单状态（管理端异常处理等）
export const updateMallOrderStatus = async (orderId, status, extra = {}) => {
    try {
        const response = await api.put(`/mall/order/${orderId}/status`, extra, {
            params: { status }
        });
        return response;
    } catch (error) {
        console.error('更新订单状态失败:', error);
        throw error;
    }
};

/** 管理端发货：顺丰下单(mode=SF) 或手工运单(mode=MANUAL) */
export const shipMallOrder = async (orderId, data = {}) => {
    try {
        const response = await api.post(`/mall/orders/${orderId}/ship`, data);
        return response;
    } catch (error) {
        console.error('订单发货失败:', error);
        throw error;
    }
};

/** 顺丰订单结果补查 */
export const searchSfOrder = async (orderNumber, params = {}) => {
    const response = await api.get(`/mall/orders/${encodeURIComponent(orderNumber)}/sf-search`, { params });
    return response;
};

/** 取消顺丰运单 */
export const cancelSfOrder = async (orderNumber) => {
    const response = await api.post(`/mall/orders/${encodeURIComponent(orderNumber)}/sf-cancel`);
    return response;
};

/** 子单号申请 */
export const applySfSubMailNo = async (orderNumber, data = {}) => {
    const response = await api.post(`/mall/orders/${encodeURIComponent(orderNumber)}/sf-sub-mailno`, data);
    return response;
};

/** 预下单 */
export const sfPreOrder = async (orderId, data = {}) => {
    const response = await api.post(`/mall/orders/${orderId}/sf-pre-order`, data);
    return response;
};

/** 截单 / 转寄 / 退回 */
export const sfIntercept = async (data) => {
    const response = await api.post('/mall/sf/intercept', data);
    return response;
};

/** 派件通知 */
export const sfDeliveryNotice = async (data) => {
    const response = await api.post('/mall/sf/delivery-notice', data);
    return response;
};

/** 清单运费查询 */
export const querySfWaybillFee = async (params = {}) => {
    const response = await api.get('/mall/sf/waybill-fee', { params });
    return response;
};

/** CX 地址簿查询 */
export const querySfAddressBook = async (data = {}) => {
    const response = await api.post('/mall/sf/address-book', data);
    return response;
};

/** 管理员：顺丰接口一键探测 */
export const probeAllSfApis = async (orderId) => {
    const response = await api.post(`/mall/orders/${orderId}/sf-probe-all`);
    return response;
};

// 更新订单状态
export const updateOrderStatus = async (id, statusData) => {
    try {
        const status = statusData?.status || statusData?.newStatus;
        const response = await api.put(`/mall/order/${id}/status`, statusData, {
            params: { status }
        });
        return response;
    } catch (error) {
        console.error('更新订单状态失败:', error);
        throw error;
    }
};


// 获取销售统计数据
export const fetchSalesStats = async (params = {}) => {
    try {
        const response = await api.get('/mall/sales/stats', { params });
        return response;
    } catch (error) {
        console.error('获取销售统计数据失败:', error);
        throw error;
    }
};

// 获取库存列表
export const fetchInventory = async (params = {}) => {
    try {
        const response = await api.get('/mall/inventory', { params });
        return response;
    } catch (error) {
        console.error('获取库存列表失败:', error);
        throw error;
    }
};

// 更新库存
export const updateInventory = async (id, inventoryData) => {
    try {
        const response = await api.put(`/mall/inventory/${id}`, inventoryData);
        return response;
    } catch (error) {
        console.error('更新库存失败:', error);
        throw error;
    }
};

// 获取物流信息
export const fetchLogistics = async (params = {}) => {
    try {
        const response = await api.get('/mall/logistics', { params });
        return response;
    } catch (error) {
        console.error('获取物流信息失败:', error);
        throw error;
    }
};

// 获取支付流水（对账列表，真实订单口径）
export const fetchPayments = async (params = {}) => {
    try {
        const response = await api.get('/mall/payments', { params });
        return response;
    } catch (error) {
        console.error('获取支付流水失败:', error);
        throw error;
    }
};

// 获取订单微信支付二维码
export const getOrderWechatQrcode = async (orderId, userId) => {
    try {
        // 使用正确的订单二维码API
        const response = await api.get(`/mall/orders/${orderId}/qrcode/wechat`);
        return response;
    } catch (error) {
        console.error('获取订单微信支付二维码失败:', error);
        throw error;
    }
};

// 获取订单支付宝支付二维码
export const getOrderAlipayQrcode = async (orderId) => {
    try {
        const response = await api.get(`/mall/orders/${orderId}/qrcode/alipay`);
        return response;
    } catch (error) {
        console.error('mall.js - 获取订单支付宝支付二维码失败:', error);
        throw error;
    }
};

// 获取订单支付二维码（兼容旧接口，默认返回微信二维码）
export const getOrderQrcode = async (orderId) => {
    try {
        const response = await api.get(`/mall/orders/${orderId}/qrcode`);
        return response;
    } catch (error) {
        console.error('获取订单支付二维码失败:', error);
        throw error;
    }
};

// 获取订单状态
export const getOrderStatus = async (orderId) => {
    try {
        const response = await api.get(`/mall/orders/${orderId}/status`);
        return response;
    } catch (error) {
        console.error('获取订单状态失败:', error);
        throw error;
    }
};

// 获取作物分类列表
export const fetchCropCategories = async (params = {}) => {
    try {
        const response = await api.get('/mall/crop-categories', { params });
        return response;
    } catch (error) {
        console.error('获取作物分类列表失败:', error);
        throw error;
    }
};

// 创建订单
export const createOrder = async (orderData) => {
    try {
        const response = await api.post('/mall/orders', orderData);
        return response;
    } catch (error) {
        console.error('创建订单失败:', error);
        throw error;
    }
};

// 更新订单收货人信息
export const updateOrderReceiverInfo = async (orderId, receiverInfo) => {
    try {
        const response = await api.put(`/mall/orders/${orderId}/receiver-info`, receiverInfo);
        return response;
    } catch (error) {
        console.error('更新订单收货人信息失败:', error);
        throw error;
    }
};

// 获取订单详情
export const getOrder = async (orderId) => {
    try {
        const response = await api.get(`/mall/orders/${orderId}`);
        return response;
    } catch (error) {
        console.error('获取订单详情失败:', error);
        throw error;
    }
};

// 获取当前用户的订单列表
export const getMyOrders = async (params = {}) => {
    try {
        const response = await api.get('/mall/order/my', { params });
        return response;
    } catch (error) {
        console.error('获取用户订单列表失败:', error);
        throw error;
    }
};

// 检查用户是否有未支付的订单
export const getPendingOrder = async () => {
    try {
        const response = await api.get('/mall/order/pending');
        return response;
    } catch (error) {
        console.error('检查未支付订单失败:', error);
        throw error;
    }
};

// ==================== 收货地址相关API ====================

// 获取用户所有收货地址
export const getUserAddresses = async (userId) => {
    try {
        const response = await api.get('/mall/address/list', {
            params: { userId }
        });
        return response.data.data.addresses || [];
    } catch (error) {
        console.error('获取收货地址列表失败:', error);
        throw error;
    }
};

// 获取收货地址详情
export const getUserAddressById = async (addressId) => {
    try {
        const response = await api.get(`/mall/addresses/${addressId}`);
        return response.data;
    } catch (error) {
        console.error('获取收货地址详情失败:', error);
        throw error;
    }
};

// 创建收货地址
export const createUserAddress = async (addressData) => {
    try {
        const response = await api.post('/mall/addresses', addressData);
        return response.data;
    } catch (error) {
        console.error('创建收货地址失败:', error);
        throw error;
    }
};

// 更新收货地址
export const updateUserAddress = async (addressId, addressData) => {
    try {
        const response = await api.put(`/mall/addresses/${addressId}`, addressData);
        return response.data;
    } catch (error) {
        console.error('更新收货地址失败:', error);
        throw error;
    }
};

// 删除收货地址
export const deleteUserAddress = async (addressId) => {
    try {
        const response = await api.delete(`/mall/addresses/${addressId}`);
        return response.data;
    } catch (error) {
        console.error('删除收货地址失败:', error);
        throw error;
    }
};

// 获取用户默认收货地址
export const getDefaultUserAddress = async (userId, type = 'default') => {
    try {
        const response = await api.get('/mall/address/default', {
            params: { userId, type }
        });
        console.log('获取默认地址API响应:', response.data);
        return response.data.data;
    } catch (error) {
        console.error('获取默认收货地址失败:', error);
        throw error;
    }
};

// 设置默认收货地址
export const setDefaultUserAddress = async (addressId) => {
    try {
        const response = await api.put(`/mall/addresses/${addressId}/default`);
        return response.data;
    } catch (error) {
        console.error('设置默认收货地址失败:', error);
        throw error;
    }
};

// 根据标签获取收货地址
export const getUserAddressesByTag = async (addressTag) => {
    try {
        const response = await api.get(`/mall/addresses/tag/${addressTag}`);
        return response.data;
    } catch (error) {
        console.error('根据标签获取收货地址失败:', error);
        throw error;
    }
};

// 统计用户收货地址数量
export const countUserAddresses = async () => {
    try {
        const response = await api.get('/mall/addresses/count');
        return response.data;
    } catch (error) {
        console.error('统计收货地址数量失败:', error);
        throw error;
    }
};

// 获取用户最近的收货地址
export const getRecentUserAddresses = async () => {
    try {
        const response = await api.get('/mall/addresses/recent');
        return response.data;
    } catch (error) {
        console.error('获取最近收货地址失败:', error);
        throw error;
    }
};

// ==================== 管理员地址管理API ====================

// 管理员获取所有用户地址列表
export const getAdminAddresses = async (params = {}) => {
    try {
        const response = await api.get('/mall/admin/addresses', { params });
        return response.data;
    } catch (error) {
        console.error('管理员获取地址列表失败:', error);
        throw error;
    }
};

// 管理员获取地址统计信息
export const getAdminAddressStats = async () => {
    try {
        const response = await api.get('/mall/admin/addresses/stats');
        return response.data;
    } catch (error) {
        console.error('获取地址统计信息失败:', error);
        throw error;
    }
};

// 管理员导出地址数据
export const exportAdminAddresses = async (params = {}) => {
    try {
        const response = await api.get('/mall/admin/addresses/export', { params });
        return response.data;
    } catch (error) {
        console.error('导出地址数据失败:', error);
        throw error;
    }
};

// ==================== 商品收藏相关API ====================

/**
 * 切换商品收藏状态
 */
export const toggleProductFavorite = async (productId) => {
    try {
        const response = await api.post(`/mall/products/${productId}/favorite`);
        return response.data;
    } catch (error) {
        console.error('切换商品收藏状态失败:', error);
        throw error;
    }
};

/**
 * 检查商品收藏状态
 */
export const checkProductFavorite = async (productId) => {
    try {
        const response = await api.get(`/mall/products/${productId}/favorite/check`);
        return response.data;
    } catch (error) {
        console.error('检查商品收藏状态失败:', error);
        throw error;
    }
};

/**
 * 获取商品收藏数量
 */
export const getProductFavoriteCount = async (productId) => {
    try {
        const response = await api.get(`/mall/products/${productId}/favorites/count`);
        return response.data;
    } catch (error) {
        console.error('获取商品收藏数量失败:', error);
        throw error;
    }
};

/**
 * 获取用户收藏的商品列表
 */
export const getUserFavorites = async () => {
    try {
        const response = await api.get('/mall/favorites');
        return response.data;
    } catch (error) {
        console.error('获取用户收藏列表失败:', error);
        throw error;
    }
};

// ==================== 结算与优惠券 ====================

export const previewSettlement = async ({ userId, items, userCouponId, pointsToUse }) => {
    try {
        const response = await api.post('/mall/settlement/preview', {
            userId,
            items,
            userCouponId,
            pointsToUse: pointsToUse || 0,
        });
        return response;
    } catch (error) {
        console.error('结算预览失败:', error);
        throw error;
    }
};

export const fetchAvailableCoupons = async ({ userId, items }) => {
    try {
        const response = await api.post('/mall/settlement/coupons/available', { userId, items });
        return response;
    } catch (error) {
        console.error('获取可用优惠券失败:', error);
        throw error;
    }
};

// ==================== 增值税专用发票申请 ====================

export const fetchVatInvoiceApplications = async (params = {}) => {
    try {
        const response = await api.get('/mall/vat-invoice-applications', { params });
        return response;
    } catch (error) {
        console.error('获取专票申请列表失败:', error);
        throw error;
    }
};

export const reviewVatInvoiceApplication = async (id, { action, rejectReason }) => {
    try {
        const response = await api.put(`/mall/vat-invoice-applications/${id}/review`, {
            action,
            rejectReason,
        });
        return response;
    } catch (error) {
        console.error('审核专票申请失败:', error);
        throw error;
    }
};

// ==================== 管理端：评价 / 售后 / 客服 ====================

export const fetchAdminComments = async (params = {}) => {
    const response = await api.get('/mall/admin/comments', { params });
    return response;
};

export const fetchAdminAfterService = async (params = {}) => {
    const response = await api.get('/mall/admin/after-service', { params });
    return response;
};

export const fetchAdminCsSessions = async (params = {}) => {
    const response = await api.get('/mall/admin/cs/sessions', { params });
    return response;
};

export const fetchAdminCsMessages = async (sessionId) => {
    const response = await api.get(`/mall/admin/cs/sessions/${encodeURIComponent(sessionId)}/messages`);
    return response;
};

export const sendAdminCsMessage = async (sessionId, content) => {
    const response = await api.post(`/mall/admin/cs/sessions/${encodeURIComponent(sessionId)}/messages`, { content });
    if (response?.data?.success === false) {
        throw new Error(response.data.message || '发送失败');
    }
    return response;
};

export const closeAdminCsSession = async (sessionId) => {
    const response = await api.post(`/mall/admin/cs/sessions/${encodeURIComponent(sessionId)}/close`);
    if (response?.data?.success === false) {
        throw new Error(response.data.message || '关闭失败');
    }
    return response;
};

// ==================== 订单操作相关API ====================

/**
 * 取消订单
 */
export const cancelOrder = async (orderId, reason = '用户取消') => {
    try {
        const response = await api.post(`/mall/enhanced/orders/${orderId}/cancel`, { reason });
        return response.data;
    } catch (error) {
        console.error('取消订单失败:', error);
        throw error;
    }
};